export default "__VITE_ASSET__c70763a3__"